import { render } from "./ProductsCarousel.vue?vue&type=template&id=34192702&scoped=true&ts=true"
import script from "./ProductsCarousel.vue?vue&type=script&lang=ts"
export * from "./ProductsCarousel.vue?vue&type=script&lang=ts"

import "./ProductsCarousel.vue?vue&type=style&index=0&id=34192702&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\nahue\\OneDrive\\Escritorio\\Proyectos\\SWMOTORES\\source\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34192702"]])

export default __exports__